
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgContactCallPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.36 0Q6.3 1.33 7.9 3.11c1.47 1.62.6 2.72-.44 4.16a.78.78 0 0 0 0 .9q1.75 2.42 4.1 4.02a.63.63 0 0 0 .85-.12q.95-1.15 2.29-1.18a1.55 1.5 61.1 0 1 .95.29q2.31 1.67 3.55 3.52a2.24 2.23-39.5 0 1-.27 2.82q-3.22 3.23-7.68 1.26Q2.89 15.07 0 6.47v-2.1Q.65 1.43 2.97 0h1.39Zm1.97 13.25c2.62 2.6 7.44 6.18 11.1 3.19a.72.72 0 0 0 .05-1.06l-2.33-2.33a.79.78 44.7 0 0-1.11 0l-1.26 1.26a.85.83-54.2 0 1-.97.16Q10.03 13.6 8 11.58q-2.04-2.02-2.93-3.8a.85.83-36.2 0 1 .16-.97l1.25-1.27a.79.78 44.9 0 0 0-1.11L4.13 2.12a.72.72 0 0 0-1.06.06c-2.96 3.68.65 8.48 3.26 11.07Z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" version=\"1.1\" viewBox=\"0.00 0.00 20.00 20.00\">\r\n<path  fill=\"white\" d=\"\r\n  M 4.36 0.00\r\n  Q 6.30 1.33 7.90 3.11\r\n  C 9.37 4.73 8.50 5.83 7.46 7.27\r\n  A 0.78 0.78 0.0 0 0 7.46 8.17\r\n  Q 9.21 10.59 11.56 12.19\r\n  A 0.63 0.63 0.0 0 0 12.41 12.07\r\n  Q 13.36 10.92 14.70 10.89\r\n  A 1.55 1.50 61.1 0 1 15.65 11.18\r\n  Q 17.96 12.85 19.20 14.70\r\n  A 2.24 2.23 -39.5 0 1 18.93 17.52\r\n  Q 15.71 20.75 11.25 18.78\r\n  Q 2.89 15.07 0.00 6.47\r\n  L 0.00 4.37\r\n  Q 0.65 1.43 2.97 0.00\r\n  L 4.36 0.00\r\n  Z\r\n  M 6.33 13.25\r\n  C 8.95 15.85 13.77 19.43 17.43 16.44\r\n  A 0.72 0.72 0.0 0 0 17.48 15.38\r\n  L 15.15 13.05\r\n  A 0.79 0.78 44.7 0 0 14.04 13.05\r\n  L 12.78 14.31\r\n  A 0.85 0.83 -54.2 0 1 11.81 14.47\r\n  Q 10.03 13.60 8.00 11.58\r\n  Q 5.96 9.56 5.07 7.78\r\n  A 0.85 0.83 -36.2 0 1 5.23 6.81\r\n  L 6.48 5.54\r\n  A 0.79 0.78 44.9 0 0 6.48 4.43\r\n  L 4.13 2.12\r\n  A 0.72 0.72 0.0 0 0 3.07 2.18\r\n  C 0.11 5.86 3.72 10.66 6.33 13.25\r\n  Z\"\r\n/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/contact-call-phone.17bce64765ed1eb9b7c537b2fadad26a.svg"),
        {
          React: SvgContactCallPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      